function mapPollyVoice(language, gender) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  switch (language) {
    case "English":
      if (gender === "male") {
        return ((_a = window.gPolly) == null ? void 0 : _a.Voices.ENGLISH_MALE) ?? 4;
      } else {
        return ((_b = window.gPolly) == null ? void 0 : _b.Voices.ENGLISH_FEMALE) ?? 3;
      }
    case "French":
      if (gender === "male") {
        return ((_c = window.gPolly) == null ? void 0 : _c.Voices.FRENCH_MALE) ?? 6;
      } else {
        return ((_d = window.gPolly) == null ? void 0 : _d.Voices.FRENCH_FEMALE) ?? 5;
      }
    case "German":
      if (gender === "male") {
        return ((_e = window.gPolly) == null ? void 0 : _e.Voices.GERMAN_MALE) ?? 8;
      } else {
        return ((_f = window.gPolly) == null ? void 0 : _f.Voices.GERMAN_FEMALE) ?? 7;
      }
    case "Spanish":
      if (gender === "male") {
        return ((_g = window.gPolly) == null ? void 0 : _g.Voices.SPANISH_MALE) ?? 10;
      } else {
        return ((_h = window.gPolly) == null ? void 0 : _h.Voices.SPANISH_FEMALE) ?? 9;
      }
    default:
      if (gender === "male") {
        return ((_i = window.gPolly) == null ? void 0 : _i.Voices.DANISH_MALE) ?? 2;
      } else {
        return ((_j = window.gPolly) == null ? void 0 : _j.Voices.DANISH_FEMALE) ?? 1;
      }
  }
}

export { mapPollyVoice };
//# sourceMappingURL=util.map-polly-voice.js.map
